import { hashStringToNumber } from "../../../shared/lib/hashString";
import { UserDto } from "../api/interfaces";

const COLORS = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "lime", "gold"];

export class UserModel {
    id: string;
    
    displayName: string;

    photo?: string;
    isAdmin?: boolean;

    constructor(params: UserDto) {
        const { id, photo, displayName, isAdmin } = params;

        this.id = id;
        this.displayName = displayName;

        this.photo = photo;
        this.isAdmin = isAdmin;
    }

    get color() {
        const hash = hashStringToNumber(this.id);

        return COLORS[hash % COLORS.length];
    }
}